import Navbar from '../Components/Navbar'
import Main from '../Components/Main.jsx'
import ButtonBar from '../Components/ButtomBar.jsx'
import Map from '../Components/Map.jsx'
import Footer from '../Components/Footer.jsx'

// import Footer from './DazyExplore.jsx'
function MapPage() {
  return (
    <>
      <Navbar/>
      <Main />
      <ButtonBar />
      <Map />
      <Footer />
      </>
  );
}

export default MapPage;